module.exports = __webpack_public_path__ + "img/guide_01.b018feb1.png";